<template>
  <div v-if="items.length > 0" class="w-full flex items-center space-x-2 px-4 py-2.5 mb-2 breadcrumb-bar">
    <button
      @click="_handleBackClick"
      class="flex items-center space-x-2 breadcrumb-back"
    >
      <b-icon pack="fas" icon="chevron-left" class="text-sm" />
      <span class="text-sm font-semibold">{{ backLabel || $t('back') || 'Volver' }}</span>
    </button>
    <span
      v-for="(item, index) in items"
      :key="`breadcrumb-${index}`"
      class="flex items-center space-x-2"
    >
      <span class="breadcrumb-separator text-sm">/</span>
      <span
        class="text-sm font-semibold"
        :class="index < items.length - 1 ? 'breadcrumb-link' : 'breadcrumb-current'"
        @click="index < items.length - 1 && _handleItemClick(index)"
      >
        {{ item.name || item.title }}
      </span>
    </span>
  </div>
</template>

<script>
export default {
  name: 'NavigationBreadcrumb',

  props: {
    items: {
      type: Array,
      default() {
        return [];
      }
    },
    backLabel: {
      type: String,
      default: null
    }
  },

  methods: {
    _handleBackClick() {
      this.$emit('back');
    },

    _handleItemClick(index) {
      this.$emit('item-click', index);
    }
  }
}
</script>

<style scoped>
.breadcrumb-bar {
  background: linear-gradient(135deg, #5577BB, #385DA5);
  border-bottom: 1px solid #1C4595;
  border-radius: 6px;
}

.breadcrumb-back {
  color: rgba(255, 255, 255, 0.85);
  transition: color 0.15s ease;
}

.breadcrumb-back:hover {
  color: #fff;
}

.breadcrumb-separator {
  color: rgba(255, 255, 255, 0.4);
}

.breadcrumb-link {
  color: rgba(255, 255, 255, 0.75);
  cursor: pointer;
  transition: color 0.15s ease;
}

.breadcrumb-link:hover {
  color: #fff;
}

.breadcrumb-current {
  color: #fff;
}
</style>
